import { usersProfileOps } from "../api/operations";
import { entityFactory } from "../hooks/useEntity";
import dayjs from "dayjs";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("profile"),
  endpoint: "users/profile",
  operations: usersProfileOps,
  roleView: [],
  roleAdmin: [],
  singularName: (t) => t("Profile"),
  name: (t) => t("Profile"),
  initialFilter: {
    from: dayjs().startOf("month").subtract(3, "months").format(),
    to: dayjs().endOf("month").format(),
  },

  noIdInUrl: true,
  dependencies: ["user"],
});

export default conf;
